<template>
    <div>
        <modal
            class="new-modal-small"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="true"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #fff !important; height: 30em !important;">
                <div class="mt-5">
                    <div v-if="company_details.is_subscribed == true" style="max-width: 450px;">
                        This user is Logged in to a Different Company. Please switch Company to View the Ticket Details.
                    </div>
                    <div v-if="company_details.is_subscribed == false" style="max-width: 450px;">
                        <img src="/static/images/icon-metro-warning.png" width="100" />
                        <h1 class="fs-18 fw-600 mt-3">Access Denied!</h1>
                        <span v-if="company_details.response.has_organization == true">
                            The DigiHelp ticket is linked with {{company_details.response.company_name}} of {{company_details.response.organization_name}} and currently you are logged into {{loggedInUser.organization_name}}
                        </span>
                        <span v-else>
                            The DigiHelp ticket is linked with {{company_details.response.company_name}} company and currently you are logged into {{loggedInUser.company_name}}
                        </span>
                    </div>
                </div>
                <div v-if="company_details.is_subscribed == true" class="d-flex align-items-center justify-content-between mt-6">
                    <button
                        type="button"
                        class="btn btn-new-primary btn-smm mr-3"
                        style="box-shadow: none;border-radius: 5px !important;"
                        @click="hideSelf" :disabled="switch_company_api_in_progress"
                    >Cancel</button>
                    <button class="btn btn-success text-white btn-smm text-capitalize position-relative" :disabled="switch_company_api_in_progress" @click="switchNewCompany" style="box-shadow: none;border-radius: 5px !important;">
                        Switch
                        <half-circle-spinner v-if='switch_company_api_in_progress' :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;top:-25px;left:30px" />
                    </button>
                </div>
                <div v-else class="d-flex align-items-center justify-content-center mt-6">
                    <button
                        type="button"
                        class="btn btn-new-primary btn-smm"
                        style="box-shadow: none;border-radius: 5px !important;"
                        @click="hideSelf"
                    >Close</button>
                </div>
            </div>
        </modal>
        <switch-company-success v-if="switch_success" @hideSuccess="hideSuccess" modal_name="switch-success" :company_success_msg="company_success_msg"></switch-company-success>
    </div>
</template>

<script>
import global from '../global.js';
import navbarMixin from '../mixins/navbarMixin.js';
import { HalfCircleSpinner } from "epic-spinners";
const SwitchCompanySuccess = () => import('../SwitchCompanySuccess');
export default {
    props: ["modal_name", "company_details"],
    mixins: [navbarMixin],
    data() {
        return{
            company_success_msg: '',
            switch_success:false,
            switch_company_api_in_progress: false
        }
    },
    components: {
        SwitchCompanySuccess,
        HalfCircleSpinner
    },
    methods: {
        showSwitchCompanySuccess() {
            this.switch_success = true;
            setTimeout(() => {
                this.$modal.show('switch-success');
            }, 500);
        },
        async switchNewCompany() {
            try {
                this.switch_company_api_in_progress = true;
                let params = {
                    company_id: this.$route.params.comp_id
                }
                let response = await this.switchCompany(params);
                if(response.token) {
                    this.new_token = response.token;
                    this.$cookie.delete("Token");
                    this.$cookie.delete('Token', {
                        domain: 'digicollect.com'
                    });
                    this.show_hide_comp_switch_dropdown = false
                    this.company_success_msg = response.message
                    this.switch_success = true;
                    setTimeout(() => {
                        this.$modal.show('switch-success');
                    }, 1000);
                }
            }
            catch(err) {
                console.log(err);
                this.switch_company_api_in_progress = false;
            }
        },
        setCookie(days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = "Token" + "=" + (this.new_token || "") + expires + ";domain=.digicollect.com; path=/";
        },
        hideSuccess() {
            this.switch_success = false;
            this.setCookie(7);
            setTimeout(() => {
                // window.location.reload();
                this.$emit('hideSwitchCompanyAfterSwitchSuccess');
                window.location.href = global.HELP_URL+'/ticketdetails/view/'+this.$route.params.id;
            }, 500);
        },
        hideSelf() {
            // this.$modal.hide(this.modal_name);
            this.$emit('hideSwitchCompany');
        }
    },
    computed: {
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        }
    },
}
</script>